export const isProjectLimitReached = (
  projectLimit: number | null,
  entitiesQuantity: number
): boolean => {
  if (projectLimit !== 0 && !projectLimit) return false;
  const unlimited = -1;
  return projectLimit !== unlimited && projectLimit <= entitiesQuantity;
};
